import { EVENT_TYPE, RUN_STATUS, TOOL_STATUS, type PostprocessingContent, type StreamEvent } from '@/lib/types';

type Handlers = {
  onRunStarted?: () => void;
  onRunCompleted?: () => void;
  onContent?: (chunk: string) => void;
  onError?: (msg: string) => void;
  onPostprocessing?: (data: { zoneCodes?: string[]; zoneDetected?: boolean; plotDetected?: boolean }) => void;
  onFollowup?: (data: { content: string }) => void;
};

export function handleEvent(event: StreamEvent, h: Handlers = {}) {
  switch (event.type) {
    case EVENT_TYPE.Run:
      if (event.status === RUN_STATUS.Started) h.onRunStarted?.();
      else if (event.status === RUN_STATUS.Completed) h.onRunCompleted?.();
      break;

    case EVENT_TYPE.Content:
      h.onContent?.(event.content as string);
      break;

    case EVENT_TYPE.Error:
      h.onError?.(event.content as string);
      break;

    case EVENT_TYPE.Tool:
      if (event.status === TOOL_STATUS.Started) console.log('[tool] started', event.name, event.arguments);
      if (event.status === TOOL_STATUS.Completed) console.log('[tool] completed', event.name, event.result);
      break;

    case EVENT_TYPE.Postprocessing: {
      const content = event.content as PostprocessingContent;
      const { zone_code, zone_detected, plot_detected } = content;
      console.log('[postprocessing]', {
        zone_code,
        zone_detected,
        plot_detected,
      });
      h.onPostprocessing?.({
        zoneCodes: zone_code,
        zoneDetected: zone_detected,
        plotDetected: plot_detected,
      });
      break;
    }

    case EVENT_TYPE.Followup:
      h.onFollowup?.({
        content: event.content as string,
      });
      break;

    default:
      console.log('[unknown event]', event);
  }
}
